import { render, staticRenderFns } from "./ListaLeads.vue?vue&type=template&id=f18b47e2"
import script from "./ListaLeads.vue?vue&type=script&lang=js"
export * from "./ListaLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports